import React, { useEffect, useState } from 'react';
import { Button, Table } from 'antd';
import './RequestTable.scss';
import { RequestDataResponse } from 'core/dashboard/types';
import { useNavigate } from 'react-router-dom';
import type { PaginationProps } from 'antd';
import { TableFilters } from 'core/visitRequestReview/types';
import { EditIcon } from 'components/Elements/CustomSVGIcon';

type LocalPaginationProps = {
    currentPage: number;
    pageSize: number;
    total: number;
    onChange: (page: number) => void;
}

interface RequestTableProps {
    columns: Array<object>;
    data: RequestDataResponse[];
    loading: boolean;
    pagination: LocalPaginationProps;
    filters: TableFilters;
}

const RequestTable: React.FC<RequestTableProps> = ({ columns, data, loading, pagination, filters }) => {
    const navigate = useNavigate();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [_, setCurrentPage] = useState(pagination.currentPage);

    const handleViewDetails = (record: RequestDataResponse) => {
        navigate(`/visitor-view-request/${record.encryptedId}`, { state: { filters } });
    };

    // Add Edit button column
    const actionsColumn = {
        title: ' ',
        key: 'actions',
        width: 80,
        render: (v: undefined, record: RequestDataResponse) => (
            <Button type="link" className="edit-button" onClick={() => handleViewDetails(record)}>
                <EditIcon />
            </Button>
        ),
    };

    // Combine original columns with actions column
    const tableColumns = [...columns, actionsColumn];

    const handleTotal = (total: number, range: [number, number]): JSX.Element => (
        <div style={{ left: 0, position: 'absolute' }}>
            Result: <span style={{ color: '#EF233C' }}>{range[0].toLocaleString()} - {range[1].toLocaleString()} of {pagination.total.toLocaleString()}</span>
        </div>
    );
    const handlePageChange = (page: number) => {
        setCurrentPage(page);
        pagination.onChange(page);
    };

    useEffect(() => {
        setCurrentPage(1);
    }, [pagination.total]);

    const itemRender: PaginationProps['itemRender'] = (page, type, originalElement) => {
        const lastPage = Math.ceil(pagination.total / pagination.pageSize);
        if (type === 'page') {
            return page === pagination.currentPage ? <div className="request-table-pagination">Page <span style={{ color: '#EF233C' }}>{page}</span> of {lastPage}</div> : null;
        }
        return originalElement;
    };

    return (
        <div className="dashboard-table-container">
            <Table
                loading={loading}
                dataSource={data}
                // Rows have no `key` field, so antd falls back to array index
                // and warns "Each child should have a unique key". encryptedId
                // is the per-row nav id; ref is a required unique fallback.
                rowKey={(record) => record.encryptedId ?? String(record.ref)}
                className="request-table"
                pagination={{
                    defaultPageSize: pagination.pageSize,
                    // defaultCurrent: 1,
                    current: pagination.currentPage,
                    total: pagination.total,
                    showSizeChanger: false,
                    itemRender,
                    showTotal: (total, range) => handleTotal(total, range),
                    onChange: handlePageChange,
                }}
                columns={tableColumns} />
        </div>
    );
};

export default RequestTable;
